import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';

const root = document.getElementById('root');
if (!('ontouchstart' in document.documentElement)) {
  root.className = 'pointer-device';
}

ReactDOM.render(<App />, root);
